import { Collapse, Divider, Spin } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
} from "../../components/styled/common";
import { DocCategoryItems } from "./constants";
import CollapseExpandIcon from "../../components/CollapseExpandIcon";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useDocCategoryContext } from "../../context/DocumentCategoryContext/DocumentCategoryContext";
import { useParams } from "react-router-dom";
import { useEffect } from "react";

const EditDocCategory = () => {
	const { id } = useParams<{ id: string }>();
	const { updateDocCategory, clearDocCategoryData, operationStatus, getDocCategoryDetails } = useDocCategoryContext();

	useEffect(() => {
		if (id) {
			clearDocCategoryData();
			getDocCategoryDetails(id);
		}

		return () => {
			clearDocCategoryData();
		};
	}, [id]);

	return (
		<ActionContainer>
			<Spin spinning={operationStatus.type === "loading" && operationStatus.operation === "fetch"}>
				<ActionItemsContainer>
					<h3>Doküman Kategorisini Düzenle</h3>
					<Divider />
					<Collapse
						items={DocCategoryItems}
						expandIconPosition="end"
						bordered={false}
						ghost
						expandIcon={CollapseExpandIcon}
						defaultActiveKey={["1"]}
					/>
					<SubmitButtonOverlay>
						<MainButtonComponent onClick={updateDocCategory} type="default" loading={operationStatus.type === "loading" && operationStatus.operation === "update"}>
							Güncelle
						</MainButtonComponent>
					</SubmitButtonOverlay>
				</ActionItemsContainer>
			</Spin>
		</ActionContainer>
	);
};

export default EditDocCategory;
